import { observableEvent } from '../_utils/observable-event';

export default class UploadAnalytics {
  static eventTypes(uploadAnalyticsArray) {
    const anyCompressed = uploadAnalyticsArray.some(
      (a) => a.upload_source === 'local-compression',
    );

    return anyCompressed ? 'local-compression' : 'raw';
  }

  constructor({
    fileName = null,
    uploadTransactionId = null,
    uploadTimings = {},
    fileUploadSource,
    fileType = null,
    batchSize = null,
  }) {
    this._transactionId = uploadTransactionId;
    this._timings = uploadTimings;

    this._fileName = fileName;
    this.fileUploadSource = fileUploadSource;
    this._fileType = fileType;
    this._batchSize = batchSize;
    // Set by the uploader once known: 'local-compression' or 'raw', and the
    // compressor's reason (null when browser compression is off).
    this.upload_source = null;
    this.compressionResult = null;
    this._fileData = {
      originalSize: null,
      compressedSize: null,
    };
  }

  // Size of the file the user picked, before any compression.
  get originalSize() {
    return this._fileData.originalSize;
  }

  setFileSizes(originalSize = null, compressedSize = null) {
    let changed = false;

    if (typeof originalSize !== null) {
      this._fileData.originalSize = originalSize;
      changed = true;
    }

    if (typeof compressedSize !== null) {
      this._fileData.compressedSize = compressedSize;
      changed = true;
    }

    return changed;
  }

  sendObservability({ attempts = 0 } = {}) {
    observableEvent.record('photo-upload-success', {
      compr_elapsed_time_ms: this._timings.compressionDuration(),
      total_elapsed_time_ms: this._timings.completeDuration(),
      compr_work_time_ms: this._timings.compressionWorkDuration(),
      upload_time_ms: this._timings.uploadDuration(),
      original_size: this._fileData.originalSize,
      optimized_size: this._fileData.compressedSize,
      num_threads: window.navigator.hardwareConcurrency,
      upload_source: this.upload_source,
      compression_result: this.compressionResult,
      file_upload_source: this.fileUploadSource ?? null,
      file_type: this._fileType,
      upload_transaction_id: this._transactionId,
      batch_size: this._batchSize,
      retries: attempts,
    });
  }
}
